import _get from 'lodash/get'

import {
    CAPITAL_GAINS_SAVE_ERROR,
    CAPITAL_GAINS_SAVE_SUCCESS,
    CAPITAL_GAINS_SAVING,
    CAPITAL_GAINS_UPDATE,
} from '../actions'

export default (
    state = {
        shouldFetch: true,
        fetchSuccessful: null,
        activeQuestionIndex: 0,
    },
    action
) => {
    switch (action.type) {
        case CAPITAL_GAINS_UPDATE:
            return { ...state, ...action.capitalGains }
        case CAPITAL_GAINS_SAVING:
            return { ...state, isSaving: true }
        case CAPITAL_GAINS_SAVE_SUCCESS:
            return {
                ...state,
                ...action.capitalGains,
                isSaving: false,
                goToNextQuestion: !action.capitalGains.isAllowanceUpdate,
                goToNextAllowanceQuestion: action.capitalGains.isAllowanceUpdate
                    ? !!action.capitalGains.shouldGoToNextAllowanceQuestion
                    : false,
                isAllowanceUpdate: false,
                saveError: false,
                errorMessage: '',
                validationErrors: null,
            }
        case CAPITAL_GAINS_SAVE_ERROR:
            return {
                ...state,
                ...action.capitalGains,
                isSaving: false,
                goToNextQuestion: false,
                goToNextAllowanceQuestion: false,
                saveError: true,
                errorMessage: _get(action, ['errorResponse', 'message'], 'Unknown error occurred'),
                validationErrors: _get(action, ['errorResponse', 'modelState'], false),
            }
        default:
            return state
    }
}
